/* Bloc 10b lot 2 — distingue le directeur école (gestion) de l'adjoint (accès
 * délégué, lecture bornée à ses groupes). L'API tranche via role_assignments +
 * direction_group_access ; le lens `direction` ne suffit pas à distinguer. */

import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useRoles } from './use-roles';

interface DirectionCapabilities {
  isDirector: boolean;
  isDelegate: boolean;
  ready: boolean;
}

export function useDirectionCapabilities(): DirectionCapabilities {
  const { activeRole } = useRoles();
  const [state, setState] = useState<DirectionCapabilities>({ isDirector: false, isDelegate: false, ready: false });

  useEffect(() => {
    if (activeRole !== 'direction') {
      setState({ isDirector: false, isDelegate: false, ready: false });
      return;
    }
    let alive = true;
    api.direction.capabilities
      .query()
      .then((c) => {
        if (alive) setState({ isDirector: c.is_director, isDelegate: c.is_delegate, ready: true });
      })
      .catch(() => {
        if (alive) setState({ isDirector: false, isDelegate: false, ready: true });
      });
    return () => {
      alive = false;
    };
  }, [activeRole]);

  return state;
}
